<template>
  <v-form ref="documentForm">
    <v-card-text>
      <v-layout wrap>
        <v-flex xs12>
          <v-text-field
            label="Display Name"
            outline
            tabindex="1"
            v-model="form.display_name"
            name="display_name"
            :hide-details="!errors.has('display_name')"
            :error="errors.has('display_name')"
            :error-count="errors.count('display_name')"
            :error-messages="errors.get('display_name')"
          ></v-text-field>
        </v-flex>
        <v-flex xs12>
          <v-autocomplete
            v-model="form.categories"
            item-text="name"
            item-value="id"
            :items="categories"
            label="Categories"
            placeholder="Select Categories"
            height="35"
            multiple
            hide-details
            small-chips
            dense
            flat
            outlined
            clearable
          ></v-autocomplete>
        </v-flex>

        <v-flex xs12>
          <v-autocomplete
            v-model="form.permission_groups"
            item-text="name"
            item-value="id"
            :items="permissionGroups"
            :allow-overflow="false"
            label="Permission Groups"
            placeholder="Select Permission Groups"
            height="35"
            multiple
            hide-details
            small-chips
            dense
            flat
            outlined
            clearable
          ></v-autocomplete>
        </v-flex>
      </v-layout>
    </v-card-text>

    <v-card-actions class="pa-3">
      <v-layout row wrap>
        <v-btn color="error" @click="deleteDocument">Delete</v-btn>
        <v-spacer></v-spacer>
        <v-btn @click="secondaryAction">{{ secondaryActionText }}</v-btn>
        <v-btn color="primary" @click="submit">{{ submitText }}</v-btn>
      </v-layout>
    </v-card-actions>
  </v-form>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import Errors from "@root/helpers/Errors";

export default {
  data() {
    return {
      form: {
        display_name: "",
        categories: [],
        permission_groups: []
      },
      errors: new Errors()
    };
  },

  props: {
    document: {
      default: false
    }
  },

  computed: {
    ...mapGetters("document_center", {
      DOCUMENTS: "documents"
    }),

    ...mapGetters("document_center", ["categories", "permissionGroups"]),

    secondaryActionText() {
      return this.document ? "Cancel" : "Reset";
    },

    submitText() {
      return this.document ? "Save Changes" : "Create Document";
    }
  },

  methods: {
    ...mapActions("document_center", {
      UPDATE_DOCUMENT: "updateDocument",
      GET_CATEGORIES: "getCategories",
      DELETE_DOCUMENT: "deleteDocument"
    }),

    secondaryAction(id) {
      if (this.document) {
        this.$router.back();
        return;
      }

      this.$refs.documentForm.reset();
      this.errors.clear();

      if (id) {
        this.$router.push(`/admin/documents/${id}`);
      }
    },

    submit() {
      this.UPDATE_DOCUMENT({
        form: this.form,
        id: this.document.id
      })
        .then(data => {
          this.secondaryAction(!this.document ? data.id : false);

          return data;
        })
        .catch(error => {
          error = Object.assign({}, error);
          this.errors.record(error.response.data.errors);
        });
    },

    deleteDocument() {
      this.$swal({
        title: "Are you sure?",
        text: "This will delete the file associated with other categories!",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, delete it!"
      }).then(result => {
        if (result.value) {
          const payload = {
            document_id: this.document.id
          };

          this.DELETE_DOCUMENT(payload).then(data => {
            if (data.success) {
              this.$router.replace("/admin/documents/");
            }
          });
        }
      });
    }
  },

  created() {
    if (this.document) {
      _.forIn(this.form, (value, key) => {
        value = this.document[key];

        if (key === "categories" || key === "permission_groups") {
          value = _.map(value, "id");
        }

        if (value) {
          this.$set(this.form, key, value);
        }
      });
    }
  }
};
</script>
